const Footer = () => {
  const footerLinkStyles = 'font-semibold text-secondary-2 hover:underline';
  return (
    <footer data-testid="login-footer" className="bg-gray-5 text-gray-1 mt-auto w-full px-8 py-8 md:px-24">
      <div>
        Legal: |{' '}
        <a className={footerLinkStyles} href="https://myosh.com/security/">
          Security
        </a>{' '}
        |{' '}
        <a className={footerLinkStyles} href="https://myosh.com/privacy/">
          Privacy
        </a>{' '}
        |{' '}
        <a className={footerLinkStyles} href="https://myosh.com/terms-and-conditions/">
          Terms and Conditions
        </a>{' '}
        |{' '}
        <a className={footerLinkStyles} href="https://myosh.com/gdpr/">
          GDPR Centre
        </a>
      </div>
      <p className="mt-1 font-semibold">
        Safety management software for every business. © {new Date().getFullYear()} myosh.
      </p>
    </footer>
  );
};

export default Footer;
